import { Alert, Button, Snackbar } from '@mui/material';

import { useVersionCheck } from '@/hooks/useVersionCheck';

export function NewVersionBanner(): JSX.Element | null {
  const { updateAvailable } = useVersionCheck();

  if (!updateAvailable) return null;

  return (
    <Snackbar open anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}>
      <Alert
        severity="info"
        variant="filled"
        action={
          <Button color="inherit" size="small" onClick={() => window.location.reload()}>
            Recargar
          </Button>
        }
        sx={{ width: '100%' }}
      >
        Hay una nueva versión de la aplicacion disponible
      </Alert>
    </Snackbar>
  );
}
